// components/PaymentMethodSelector.tsx
import { useState } from 'react'
import { useStripe, useElements, Elements, PaymentElement } from '@stripe/react-stripe-js'
import Modal from './Modal' // make sure this does NOT portal to document.body (see notes)
import { loadStripe } from '@stripe/stripe-js'
import { useAnnualPlan } from '../../hooks/featureFlags'
import Button from '../Buttons'

function PaymentMethodSelector() {
	const stripe = useStripe()
	const elements = useElements()
	const [annual] = useAnnualPlan()
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState<string | null>(null)

	const handleSubmit = async (event: React.FormEvent) => {
		event.preventDefault()
		setLoading(true)
		setError(null)

		if (!stripe || !elements) return

		const { error: confirmError } = await stripe.confirmPayment({
			elements,
			confirmParams: {
				return_url:
					window.location.origin + `/purchase/?paddleSuccess=true&showModal=true${annual ? '&annual=true' : ''}`,
			},
		})

		if (confirmError) {
			setError(confirmError.message ?? null)
		}

		setLoading(false)
	}

	return (
		<Modal open={true} closeModal={() => {}} portalClassName="update-payment-method">
			<div className="p-4 mt-4 max-w-md w-screen">
				<h3 className="text-2xl font-bold mb-5 text-center">Update Payment Method</h3>
				<form onSubmit={handleSubmit}>
					<div className="mb-4">
						<PaymentElement />
					</div>
					{error && <p className="text-red-500 text-sm mb-3 dark:text-red-400">{error}</p>}
					<div className="flex space-x-2">
						<Button type="default" htmlType="submit" className="w-full mt-2" disabled={!stripe || loading}>
							{loading ? 'Processing...' : 'Update'}
						</Button>
					</div>
				</form>
			</div>
		</Modal>
	)
}

const stripePromise = loadStripe(
	'pk_live_51KXx04ApflHFLqu66s7RJuXDpQMqxcP4Hr3YmgRCFPP4Ylm7sNmWiP5mVddhxi2iqdSkvWkheM3zd6nJ6HhOrBaf00l05v3pXq'
)

const StripePaymentMethodSelector = ({ clientSecret }: { clientSecret: string }) => {
	if (!clientSecret) {
		return null
	}
	return (
		<Elements
			stripe={stripePromise}
			options={{ clientSecret }}
			// If clientSecret can change, the key forces a re-mount
			key={clientSecret}
		>
			<PaymentMethodSelector />
		</Elements>
	)
}

export default StripePaymentMethodSelector
